const initialState = {
  statistics: [],
  pages: {current_page: 1},
  keywordName: ''
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
      case "SET_TABLE":
        return { ...state, statistics: action.payload};
      case 'GET_KEYWORD_STATS_SUCCESS':
        return {...state, statistics: action.data.data, pages: action.data.pages, keywordName: action.data.keyword_name};
      case 'GET_KEYWORD_STATS_FAILED':
        return { ...state };
    default:
      return { ...state };
  }
}
